import { render, staticRenderFns } from "./VideoTourModal.vue?vue&type=template&id=2c1f4174"
import script from "./VideoTourModal.vue?vue&type=script&lang=js"
export * from "./VideoTourModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports